/* jshint esversion: 6 */

const Validate = {
  isValidEmail: function(email) {
    return !!/^[a-zA-Z0-9\.!#$%&'*+\-\/=\?^_`{|}~\-]+@([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9\-]{2,}$/.test(email);
  }
};
export const {isValidEmail} = Validate;
